import React from 'react';
import { Bar } from 'react-chartjs-2';
import { barOptions, barVerticalOptions } from './config';

const BarComponent = ({ data, type }) => {
  const getOptions = () => {
    if (type == 'vertical') {
      return barVerticalOptions;
    }
    return barOptions;
  }
  return (
    <Bar data={data} options={getOptions()} />
  );
}

export default BarComponent;